import {Component} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {UserConfigService} from './auth/user-config.service';
import {filter, tap} from 'rxjs/operators';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    standalone: false
})
export class AppComponent {
  showSearch = true;

  constructor(public route: ActivatedRoute, public userConfig: UserConfigService,
              public router: Router) {
  }

  loading = true;

  ngOnInit(): void {
    this.route.data.subscribe((data: any) => {
      this.showSearch = data.showSearch;
    });

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.loading = false;
    });
  }
}
